import { useFormContext } from 'react-hook-form';
import { thousandFormatNumbroCurrency } from '@fintronners/react-utils/src/numberUtilsTSX';
import { WebCaption10 } from '@fintronners/react-ui/src/GlobalStyling/webTypography';
import { useTranslation } from 'react-i18next';

import { TransferCurrencyInput } from '../TransferCurrencyInput';
import { RecurringDepositIntervalOptions } from './RecurringDepositIntervalOptions';
import { InfoWithIcon } from '../InfoWithIcon';
import { Skeleton } from '@/components/common/Skeleton';
import { ErrorMessage } from '@/components/common/Forms/feedback/ErrorMessage';

export type RecurringDepositFormProps = {
  availableInstantDepositLimit: string;
  isLoading: boolean;
};

export const RecurringDepositForm = ({
  availableInstantDepositLimit,
  isLoading,
}: RecurringDepositFormProps) => {
  const {
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <TransferCurrencyInput />
      {isLoading ? (
        <Skeleton className="h-4 w-full" />
      ) : (
        <InfoWithIcon
          message={t('miscScreens.deposits.instantDepositLimit', {
            limit: thousandFormatNumbroCurrency(availableInstantDepositLimit),
          })}
        />
      )}

      <WebCaption10.Regular className="text-grey55">
        {t('miscScreens.deposits.instantDepositTimeWindow')}
      </WebCaption10.Regular>

      <RecurringDepositIntervalOptions />
      {errors.interval && <ErrorMessage hasIcon>{String(errors.interval.message)}</ErrorMessage>}
    </>
  );
};
